import React from 'react'
import PropTypes from 'prop-types'
import { getDisplayName } from 'recompose'
import { ApolloProvider } from 'react-apollo'
import { IntrospectionFragmentMatcher } from 'apollo-cache-inmemory'

import apollo from './apollo'

export default ComposedComponent =>
  class WithData extends React.Component {
    static displayName = `WithData(${getDisplayName(ComposedComponent)})`

    static propTypes = {
      __APOLLO_STATE__: PropTypes.object,
      __APOLLO_INSTROSPECTION__: PropTypes.object,
    }

    constructor(props) {
      super(props)

      // @TODO: Configure instrospection.
      const fragmentMatcher = new IntrospectionFragmentMatcher({
        introspectionQueryResultData: this.props.__APOLLO_INSTROSPECTION__,
      })

      this.apollo = apollo({
        initialState: this.props.__APOLLO_STATE__,
        cacheOptions: { fragmentMatcher },
      })
    }

    render() {
      // Extract Apollo state, for ComposedComponent doesn't need to know it existed.
      const {
        __APOLLO_STATE__,
        __APOLLO_INSTROSPECTION__,
        ...props
      } = this.props

      return (
        <ApolloProvider client={this.apollo}>
          <ComposedComponent {...props} />
        </ApolloProvider>
      )
    }
  }
